export const custodyLanes = {
  PUBLIC_DOMAIN_COUNTABLE: "PUBLIC_DOMAIN_COUNTABLE",
  SOURCE_ANCHOR_ONLY: "SOURCE_ANCHOR_ONLY",
  LICENSED_MODERN_TRANSLATION: "LICENSED_MODERN_TRANSLATION",
  BLOCKED_UNVERIFIED: "BLOCKED_UNVERIFIED"
};

export const corpusManifest = [
  {
    id: "pg-sunzi-giles-1910",
    title: "The Art of War",
    author: "Sunzi",
    translator: "Lionel Giles",
    tradition: "Chinese military classics",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/132",
    localPath: "corpus/public-domain/art-of-war-giles-1910/pg132.txt",
    sha256: "c478f7e05a07bf190585fcea0bc4658ce22e47949ac18444eca53fb274878ffe",
    byteCount: 342105,
    licenseBasis: "Project Gutenberg marks this work public domain in the USA.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_all_sunzi_translations_counted", "claim_cleary_counted"],
    verificationNotes: [
      "Downloaded from Project Gutenberg cache on 2026-06-19.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "pg-song-celestial-arnold-1900",
    title: "The Song Celestial; Or, Bhagavad-Gita",
    author: "Classical Sanskrit Bhagavad-Gita tradition",
    translator: "Sir Edwin Arnold",
    tradition: "Indian wisdom, duty, action, self-governance",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/2388",
    localPath: "corpus/public-domain/song-celestial-arnold-1885/pg2388.txt",
    sha256: "85b22401a9d256179f9a2e407215eb516da9b8213f23c32e03d66709d839a9e0",
    byteCount: 147501,
    licenseBasis: "Project Gutenberg text with reuse permission in the United States; downloaded from the Project Gutenberg ebook 2388 plain-text link.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_all_gita_translations_counted", "claim_religious_authority", "claim_predictive_validation"],
    verificationNotes: [
      "Downloaded from Project Gutenberg ebook 2388 plain-text accessible file on 2026-06-20.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "pg-tao-teh-king-legge-1891",
    title: "The Tao Teh King, or the Tao and its Characteristics",
    author: "Laozi",
    translator: "James Legge",
    tradition: "Taoist state regulation, non-force, polarity, restraint",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/216",
    localPath: "corpus/public-domain/tao-teh-king-legge-1891/pg216.txt",
    sha256: "041568f8dfef3ac6c2deb7699756f9d26d6aa8669647f4ce611b0ed4a95b0db6",
    byteCount: 80552,
    licenseBasis: "Project Gutenberg text with reuse permission in the United States; downloaded from the Project Gutenberg ebook 216 plain-text link.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_all_taoist_texts_counted", "oracle_claims", "claim_predictive_validation"],
    verificationNotes: [
      "Downloaded from Project Gutenberg ebook 216 plain-text accessible file on 2026-06-20.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "pg-dhammapada-muller-1881",
    title: "Dhammapada, a Collection of Verses",
    author: "Canonical Buddhist/Pali tradition",
    translator: "F. Max Muller",
    tradition: "Buddhist attention, conduct, conflict reduction",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/2017",
    localPath: "corpus/public-domain/dhammapada-muller-1881/pg2017.txt",
    sha256: "f2d09ebf28af0bf87ae7be7635d485b142e6526cb2cc164ba01c74586ff547bb",
    byteCount: 88619,
    licenseBasis: "Project Gutenberg text with reuse permission in the United States; downloaded from the Project Gutenberg ebook 2017 plain-text link.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_all_buddhist_texts_counted", "medical_or_therapy_claims", "spiritual_authority_claims"],
    verificationNotes: [
      "Downloaded from Project Gutenberg ebook 2017 plain-text accessible file on 2026-06-20.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "pg-bushido-nitobe-1908",
    title: "Bushido, the Soul of Japan",
    author: "Inazo Nitobe",
    translator: null,
    tradition: "Japanese martial ethics, self-control, rectitude",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/12096",
    localPath: "corpus/public-domain/bushido-nitobe-1908/pg12096.txt",
    sha256: "ceb5f526b47fa46bfa7fb9e8bcdec224d785f6d61b7793a086847af30369b8ed",
    byteCount: 224119,
    licenseBasis: "Project Gutenberg text with reuse permission in the United States; downloaded from the Project Gutenberg ebook 12096 plain-text link.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_musashi_text_counted", "claim_all_japanese_strategy_counted", "claim_moral_authority"],
    verificationNotes: [
      "Downloaded from Project Gutenberg ebook 12096 plain-text accessible file on 2026-06-20.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "pg-prince-machiavelli-marriott-1908",
    title: "The Prince",
    author: "Niccolo Machiavelli",
    translator: "W. K. Marriott",
    tradition: "Renaissance statecraft, power, prudence, force, risk",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/1232",
    localPath: "corpus/public-domain/the-prince-machiavelli-marriott-1908/pg1232.txt",
    sha256: "f136e6c198b831dae14576cf67b81834b7a09c1e416a460a2a62973f3fd54b75",
    byteCount: 308022,
    licenseBasis: "Project Gutenberg text with reuse permission in the United States; downloaded from the Project Gutenberg ebook 1232 plain-text link.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_all_machiavelli_texts_counted", "political_advice_claims", "claim_predictive_validation"],
    verificationNotes: [
      "Downloaded from Project Gutenberg ebook 1232 plain-text accessible file on 2026-06-20.",
      "Header states title, author, translator, ebook number, and Project Gutenberg reuse terms.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "pg-on-war-clausewitz-graham-1874",
    title: "On War",
    author: "Carl von Clausewitz",
    translator: "J. J. Graham",
    tradition: "Military theory, uncertainty, friction, probability, center of gravity",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/1946",
    localPath: "corpus/public-domain/on-war-clausewitz-graham-1874/pg1946.txt",
    sha256: "c3ff450c013df060f3948d50a0b5162124b852a76f881845d2bf85e859b33d7b",
    byteCount: 1736560,
    licenseBasis: "Project Gutenberg text with reuse permission in the United States; downloaded from the Project Gutenberg ebook 1946 plain-text link.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_all_clausewitz_editions_counted", "military_advice_claims", "claim_predictive_validation"],
    verificationNotes: [
      "Downloaded from Project Gutenberg ebook 1946 plain-text accessible file on 2026-06-20.",
      "Header states title, author, translator, ebook number, and Project Gutenberg reuse terms.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "pg-meditations-marcus-aurelius",
    title: "Meditations",
    author: "Marcus Aurelius",
    translator: null,
    tradition: "Stoic attention, judgment, self-governance, action",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/2680",
    localPath: "corpus/public-domain/meditations-marcus-aurelius/pg2680.txt",
    sha256: "3ac9648961664c99e8bafe46224e16b08c1e67c9cb5f4c6da138b9d675028899",
    byteCount: 425308,
    licenseBasis: "Project Gutenberg text with reuse permission in the United States; downloaded from the Project Gutenberg ebook 2680 plain-text link.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_all_stoic_texts_counted", "medical_or_therapy_claims", "spiritual_authority_claims"],
    verificationNotes: [
      "Downloaded from Project Gutenberg ebook 2680 plain-text accessible file on 2026-06-20.",
      "Header states title, author, ebook number, and Project Gutenberg reuse terms; no translator field is present in the local header.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "pg-leviathan-hobbes-1651",
    title: "Leviathan",
    author: "Thomas Hobbes",
    translator: null,
    tradition: "Governance, covenant enforcement, security, state power",
    lane: custodyLanes.PUBLIC_DOMAIN_COUNTABLE,
    sourceUrl: "https://www.gutenberg.org/ebooks/3207",
    localPath: "corpus/public-domain/leviathan-hobbes-1651/pg3207.txt",
    sha256: "3de1e492641d939567a8b0de827fb13e1ad992324f9ac8b204f60475009b7294",
    byteCount: 1254939,
    licenseBasis: "Project Gutenberg text with reuse permission in the United States; downloaded from the Project Gutenberg ebook 3207 plain-text link.",
    allowedUses: ["local_counting", "quoted_short_excerpts", "operator_extraction"],
    blockedUses: ["claim_governance_advice", "claim_authoritarian_endorsement", "claim_predictive_validation"],
    verificationNotes: [
      "Downloaded from Project Gutenberg ebook 3207 plain-text accessible file on 2026-06-20.",
      "Header states title, author, ebook number, and Project Gutenberg reuse terms.",
      "Hash and byte count recorded locally."
    ]
  },
  {
    id: "ctext-sunzi",
    title: "Sunzi Bingfa / The Art of War",
    author: "Sunzi",
    translator: "Chinese Text Project bilingual display includes Lionel Giles for some pages",
    tradition: "Chinese military classics",
    lane: custodyLanes.SOURCE_ANCHOR_ONLY,
    sourceUrl: "https://ctext.org/art-of-war/energy",
    localPath: null,
    sha256: null,
    byteCount: null,
    licenseBasis: "Use as source anchor only until reuse terms and ingestion permissions are reviewed.",
    allowedUses: ["source_anchor", "chapter_map", "term_anchor"],
    blockedUses: ["local_counting", "redistribution", "bulk_ingestion_without_terms_review"],
    verificationNotes: ["CTEXT lists Art of War chapters and related military texts."]
  },
  {
    id: "ctext-seven-military-classics",
    title: "Seven Military Classics source family",
    author: "Sunzi, Wu Qi, Jiang Ziya, Sima Rangju, Wei Liao, Huang Shigong, Tang Taizong/Li Weigong",
    translator: null,
    tradition: "Chinese military classics",
    lane: custodyLanes.SOURCE_ANCHOR_ONLY,
    sourceUrl: "https://ctext.org/art-of-war/energy",
    localPath: null,
    sha256: null,
    byteCount: null,
    licenseBasis: "CTEXT source map only; no local custody.",
    allowedUses: ["canonical_inventory", "source_anchor"],
    blockedUses: ["claim_counted", "publish_full_text_from_ctext"],
    verificationNotes: ["CTEXT navigation includes Wu Zi, Liu Tao, Si Ma Fa, Wei Liao Zi, and Three Strategies."]
  },
  {
    id: "ctext-guiguzi",
    title: "Gui Gu Zi",
    author: "Attributed to Guiguzi tradition",
    translator: null,
    tradition: "Chinese persuasion and counsel",
    lane: custodyLanes.SOURCE_ANCHOR_ONLY,
    sourceUrl: "https://ctext.org/gui-gu-zi",
    localPath: null,
    sha256: null,
    byteCount: null,
    licenseBasis: "Source anchor only until terms and lawful ingestion are reviewed.",
    allowedUses: ["source_anchor", "operator_modeling"],
    blockedUses: ["claim_counted", "bulk_ingestion_without_terms_review"],
    verificationNotes: ["Used to anchor influence, access, and intent-knowledge models."]
  },
  {
    id: "ctext-i-ching",
    title: "Book of Changes / I Ching",
    author: "Classical Chinese composite text",
    translator: null,
    tradition: "Change, divination, governance, pattern logic",
    lane: custodyLanes.SOURCE_ANCHOR_ONLY,
    sourceUrl: "https://ctext.org/book-of-changes",
    localPath: null,
    sha256: null,
    byteCount: null,
    licenseBasis: "Source anchor only until terms and lawful ingestion are reviewed.",
    allowedUses: ["source_anchor", "change_model_design"],
    blockedUses: ["claim_counted", "oracle_claims", "bulk_ingestion_without_terms_review"],
    verificationNotes: ["Anchors state-transition and timing/context models."]
  },
  {
    id: "shambhala-cleary-strategy-guide",
    title: "Thomas Cleary strategy, power, and martial arts translations",
    author: "Multiple classical authors",
    translator: "Thomas Cleary",
    tradition: "Strategy, power, martial arts",
    lane: custodyLanes.LICENSED_MODERN_TRANSLATION,
    sourceUrl: "https://www.shambhala.com/thomas-cleary-translations-art-of-war-martial-arts/",
    localPath: null,
    sha256: null,
    byteCount: null,
    licenseBasis: "Modern published translations; use bibliographic/source-anchor records unless lawful licensed files are supplied.",
    allowedUses: ["bibliographic_inventory", "source_anchor", "manual_user_owned_notes"],
    blockedUses: ["claim_all_cleary_counted", "full_text_ingestion_without_license", "long_quotation"],
    verificationNotes: [
      "Shambhala verifies Cleary's Art of War, Mastering the Art of War, Lost Art of War, Book of Five Rings, and Yagyu-related strategy publications.",
      "Not countable without licensed local text files."
    ]
  },
  {
    id: "shambhala-cleary-i-ching-guide",
    title: "Thomas Cleary I Ching translations",
    author: "I Ching commentators and traditions",
    translator: "Thomas Cleary",
    tradition: "I Ching, Taoist, Buddhist, organizational change",
    lane: custodyLanes.LICENSED_MODERN_TRANSLATION,
    sourceUrl: "https://www.shambhala.com/i-ching-translations-thomas-cleary/",
    localPath: null,
    sha256: null,
    byteCount: null,
    licenseBasis: "Modern published translations; bibliographic/source-anchor only.",
    allowedUses: ["bibliographic_inventory", "source_anchor"],
    blockedUses: ["claim_counted", "full_text_ingestion_without_license"],
    verificationNotes: ["Shambhala describes Taoist I Ching, Buddhist I Ching, Tao of Organization, and I Ching Book of Changes editions."]
  },
  {
    id: "recovered-glyph-cleary-audit",
    title: "Cleary + Ancient Wisdom Corpus Mathematical Audit",
    author: "Recovered Genesis-Glyph-Forge research lane",
    translator: null,
    tradition: "Recovered research input",
    lane: custodyLanes.SOURCE_ANCHOR_ONLY,
    sourceUrl: "local:/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/CLEARY_AND_ANCIENT_CORPUS_MATH_AUDIT.md",
    localPath: "/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/CLEARY_AND_ANCIENT_CORPUS_MATH_AUDIT.md",
    sha256: "68f66a88f89a119dfa5c9fcad983fb09b7ddbb0b9593be1a967efca43bf9e22d",
    byteCount: 14925,
    licenseBasis: "Local recovered planning artifact; use as research input, not counted corpus.",
    allowedUses: ["operator_seed", "claim_boundary"],
    blockedUses: ["claim_full_corpus_counted", "claim_production_proof"],
    verificationNotes: ["States exact counts require corpus files, scripts, raw outputs, and spot checks."]
  },
  {
    id: "recovered-glyph-equation-registry",
    title: "Equation Registry - Genesis Glyph Forge",
    author: "Recovered Genesis-Glyph-Forge research lane",
    translator: null,
    tradition: "Recovered operator-model research input",
    lane: custodyLanes.SOURCE_ANCHOR_ONLY,
    sourceUrl: "local:/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/EQUATION_REGISTRY.md",
    localPath: "/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/EQUATION_REGISTRY.md",
    sha256: "cb8479eff9f1fd192cf3cac2b510c7931d0b322add37b9a3b58c65a4f2a0db7b",
    byteCount: 7789,
    licenseBasis: "Local recovered research artifact; anchors operator model history and caution labels only.",
    allowedUses: ["operator_seed", "source_anchor", "claim_boundary"],
    blockedUses: ["claim_formal_proof", "claim_full_corpus_counted", "claim_academic_verification"],
    verificationNotes: [
      "Recovered file labels equations as SOURCE_ANCHORED, OPERATOR_MODEL, DRAFT, NEEDS_CORPUS_AUDIT, or NEEDS_EXPERIMENT.",
      "Not counted as ancient corpus text."
    ]
  },
  {
    id: "recovered-glyph-validation-sources",
    title: "Validation Sources - Genesis Glyph Forge",
    author: "Recovered Genesis-Glyph-Forge research lane",
    translator: null,
    tradition: "Recovered validation-source research input",
    lane: custodyLanes.SOURCE_ANCHOR_ONLY,
    sourceUrl: "local:/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/VALIDATION_SOURCES.md",
    localPath: "/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/VALIDATION_SOURCES.md",
    sha256: "a63999d0bf49ddabf477b65595ae0646131b57843cd316dd96261b3f72f58d4d",
    byteCount: 4356,
    licenseBasis: "Local recovered research artifact; anchors validation-source cautions only.",
    allowedUses: ["source_anchor", "claim_boundary", "validation_note"],
    blockedUses: ["claim_equations_proven", "claim_external_sources_validate_project_equations", "claim_predictive_accuracy"],
    verificationNotes: [
      "Recovered file says external sources validate concepts and terminology only.",
      "Not counted as ancient corpus text."
    ]
  }
];

export function manifestSummary(manifest = corpusManifest) {
  return manifest.reduce(
    (summary, source) => {
      summary.total += 1;
      summary[source.lane] = (summary[source.lane] ?? 0) + 1;
      if (source.lane === custodyLanes.PUBLIC_DOMAIN_COUNTABLE) summary.countable += 1;
      return summary;
    },
    { total: 0, countable: 0 }
  );
}
